import { render, staticRenderFns } from "./StatusStatistics.vue?vue&type=template&id=369aab6e&"
import script from "./StatusStatistics.vue?vue&type=script&lang=js&"
export * from "./StatusStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StatusStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports